import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';

export default function ConciliacaoBancariaSearch({ setOption }) {
  return (
    <div>
      <ContainerSection>
        <h3>Conciliação Bancária</h3>
        <div>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Conta Bancária"
              id="ContaBancaria"
              optionsArray={['', '999 | 9999 | 9999-9 | Caixinha']}
              widthPercentage="30%"
            />
            <InputDate title="Período Inicial" id="PeriodoInicial" widthPercentage="30%" />
            <InputDate title="Período Final" id="PeriodoFinal" widthPercentage="30%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Lançamento Inicial" id="LancamentoInicial" widthPercentage="30%" />
            <InputText title="Lançamento Final" id="LancamentoFinal" widthPercentage="30%" />
            <SelectAndOptions
              title="Situação"
              id="Situacao"
              optionsArray={['', 'Todos', 'Conciliados', 'Não Conciliados']}
              widthPercentage="30%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Origem"
              id="OrigemConciliacao"
              optionsArray={[
                '',
                'Todas',
                'Manual',
                'Contas a Pagar',
                'Contas a Receber',
                'Frente de Caixa',
                'Cheque Recebido',
                'Cheque Emitido',
                'Controle de Cartões',
                'Transf. entre Contas',
                'Lançamento em Conta',
              ]}
              widthPercentage="30%"
            />
          </WrapperInputsNewSystem>
          <ButtonsSearch />
        </div>
      </ContainerSection>
      <WrapperInputsNewSystem>
        <ContainerSection>
          <div>
            <h3>Totalizadores Extrato</h3>
            <WrapperInputsNewSystem>
              <ul>
                <li>Receitas : R$ {0.0}</li>
                <li>Despesas: R$ {0.0}</li>
                <li>Saldo: R$ {0.0}</li>
                <li>Valor não conciliado : R$ {0.0}</li>
                <li>Valor conciliado : R$ {0.0}</li>
              </ul>
            </WrapperInputsNewSystem>
          </div>
        </ContainerSection>
        <ContainerSection>
          <div>
            <h3>Totalizadores Sistema</h3>
            <WrapperInputsNewSystem>
              <ul>
                <li>Receitas : R$ {0.0}</li>
                <li>Despesas: R$ {0.0}</li>
                <li>Saldo: R$ {0.0}</li>
                <li>Valor não conciliado : R$ {0.0}</li>
                <li>Valor conciliado : R$ {0.0}</li>
              </ul>
            </WrapperInputsNewSystem>
          </div>
        </ContainerSection>
      </WrapperInputsNewSystem>
      <HeaderButtons>
        <ButtonOptions buttonName="Lançamento em contas" border="#333F50" yourFunction={() => setOption('add')} />
        <ButtonOptions buttonName="Conciliar lançamentos" border="#333F50" />
        <ButtonOptions buttonName="Desfazer conciliação" border="#333F50" disabled={true} />
      </HeaderButtons>
    </div>
  );
}
